import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import styled from 'styled-components';

interface SizeCounterProps {
  onChange: (newValue: number) => void;
  value: number;
  max?: number;
  min?: number;
}

const SizeCounter: React.FC<SizeCounterProps> = ({ value, onChange, min = 1, max = 5 }) => {
  const { t } = useTranslation();

  const handleIncrease = () => onChange(Math.min(value + 1, max));
  const handleDecrease = () => onChange(Math.max(value - 1, min));

  return (
    <SizeButtonGroup size="small" variant="contained">
      <SizeButton onClick={handleDecrease} disabled={value === min} sx={{ minWidth: 30 }}>
        <SizeButtonLabel disabled={value === min}>{t('decrement')}</SizeButtonLabel>
      </SizeButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 26,
          height: 20,
          color: '#142e38',
          fontWeight: 400,
          border: '1px solid #6767e0',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        <Typography variant="body1">{value}</Typography>
      </Box>
      <SizeButton onClick={handleIncrease} disabled={value === max} sx={{ minWidth: 30 }}>
        <SizeButtonLabel disabled={value === max}>{t('increment')}</SizeButtonLabel>
      </SizeButton>
    </SizeButtonGroup>
  );
};

const SizeButtonGroup = styled(ButtonGroup)`
  display: flex;
  gap: 3px;
  height: 18px !important;
  min-height: 18px !important;
  box-shadow: none;
`;

const SizeButton = styled(Button)`
  justify-content: center !important;
  min-width: 18px !important;
  min-height: 16px !important;
  padding: 0;
  border: 1px solid #fff !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  box-shadow: ${({ theme }) => theme.shadows[0]} !important;
`;

const SizeButtonLabel = styled(({ disabled, ...rest }) => <Typography {...rest} />)<{
  disabled?: boolean;
}>`
  font-size: 20px;
  font-weight: 400;
  color: ${({ disabled }) => (disabled ? '#e2e2e2' : '#142e38')};
`;

export { SizeButton, SizeButtonGroup, SizeButtonLabel, SizeCounter };
